import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";
import api, { eur } from "../lib/api";

const THEME = [["limoncello", "liquori"], ["spritz", "fusti"], ["fusto", "fusti"], ["granit", "granite"], ["collezione", "collezione"]];
export const categoryForSlug = (slug = "") => (THEME.find(([k]) => slug.includes(k)) || [null, "liquori"])[1];
const LABEL = { liquori: "I nostri liquori", fusti: "Cocktail in fusto 19L", granite: "Preparati per granita", collezione: "La Collezione" };

export const RelatedProducts = ({ slug }) => {
  const [items, setItems] = useState([]);
  const cat = categoryForSlug(slug);
  useEffect(() => {
    api.get("/products").then(({ data }) => setItems((data || []).filter((p) => p.category === cat && p.active !== false).slice(0, 3))).catch(() => {});
  }, [cat]);
  if (!items.length) return null;
  const b2b = cat === "fusti" || cat === "granite";
  return (
    <div className="mt-12 pt-10 border-t border-stone-200" data-testid="related-products">
      <div className="eyebrow text-[#C2593F] mb-2">Prodotti correlati</div>
      <h3 className="font-serif text-2xl font-semibold text-[#0B2A45] mb-6">{LABEL[cat]}</h3>
      <div className="grid sm:grid-cols-3 gap-5">
        {items.map((p) => (
          <Link key={p.id || p.slug} to={`/prodotto/${p.slug}`} data-testid={`related-product-${p.slug}`}
            className="group bg-white rounded-2xl border border-stone-200 overflow-hidden hover:shadow-lg hover:-translate-y-0.5 transition-[transform,box-shadow]">
            <div className="aspect-[4/3] bg-stone-100 overflow-hidden"><img src={p.image_url} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
            <div className="p-5">
              <div className="font-serif font-semibold text-[#0B2A45] leading-snug">{p.name}</div>
              <div className="text-xs text-stone-500 mt-1">{p.format}</div>
              <div className="mt-3 text-sm font-semibold flex items-center gap-1 text-[#0F4C81]">
                {b2b ? <><Lock className="w-3.5 h-3.5" />Prezzo operatori</> : eur(p.public_price)}
                <ArrowRight className="w-4 h-4 ml-auto text-[#C2593F]" />
              </div>
            </div>
          </Link>
        ))}
      </div>
      <Link to={b2b ? "/listino" : cat === "collezione" ? "/negozio?cat=collezione" : "/negozio"} className="inline-flex items-center gap-1 mt-6 text-sm font-semibold text-[#C2593F]" data-testid="related-products-all">
        {b2b ? "Vai al listino operatori" : "Vai al negozio"} <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};
